import { render, staticRenderFns } from "./whitelabelManagement.vue?vue&type=template&id=571137f5&"
import script from "./whitelabelManagement.vue?vue&type=script&lang=js&"
export * from "./whitelabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./whitelabelManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports